import styled, { css } from 'styled-components';
import { styledTheme } from 'components/StyledUi/theme';
import { StyledUiContainerProps } from '../StyledUiGlobal.types';

export interface TooltipWrapperContainerProps extends StyledUiContainerProps {
  /** control externally */
  isOpen?: boolean;
  width?: number;
  textColor?: string;
  backGroundColor?: string;
  fixedBottom?: string;
  fixedLeft?: string;
  rightShift?: number;
}

/* dimensions of arrow, units are defined in the css */
const arrowWidth = 6;

const arrowStyles = css<TooltipWrapperContainerProps>`
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  transform: translateX(-${arrowWidth}px);
  left: ${({ left }) => (left ? `${left}%` : '50%')};
  border-left: ${arrowWidth}px solid transparent;
  border-right: ${arrowWidth}px solid transparent;
  border-top: ${arrowWidth}px solid
    ${({ backGroundColor }) =>
      backGroundColor ? `${backGroundColor}` : `${styledTheme.color.main}`};
`;

export const TooltipContent = styled.div<TooltipWrapperContainerProps>`
  animation-direction: reverse;
  position: absolute;
  z-index: 1000;
  padding: 6px 8px;
  width: ${({ width }) => (width ? `${width}rem` : 'max-content')};
  left: ${({ rightShift }) => (rightShift ? `${rightShift + 50}%` : '50%')};
  transition: opacity 250ms ease;
  grid-row: 1;
  grid-colum: 1;
  transform: translate(-50%, 0);

  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  border-radius: ${styledTheme.radius.sm};
  background-color: ${({ backGroundColor }) =>
    backGroundColor ? `${backGroundColor}` : `${styledTheme.color.main}`};
  color: ${({ textColor }) => (textColor ? `${textColor}` : `${styledTheme.color.neg}`)};
  text-align: center;

  &.fixed-top {
    position: fixed;
    bottom: ${({ fixedBottom }) => fixedBottom} !important;
    left: ${({ fixedLeft }) => fixedLeft};
    height: fit-content;
  }

  &:before {
    ${arrowStyles};
  }
  box-shadow: 0px 6px 12px 6px rgba(16, 24, 40, 0.1);

  &.tooltip--bottom {
    top: 100%;

    margin-top: ${arrowWidth + 3}px;

    &:before {
      top: -${arrowWidth - 2}px;
      transform: rotate(180deg) translateX(${arrowWidth}px);
    }
  }

  &.tooltip--top {
    bottom: 100%;
    font-size: 0.85rem;
    margin-bottom: ${arrowWidth}px;

    &:before {
      bottom: -${arrowWidth - 2}px;
    }
  }

  &.tooltip--left {
    top: 5%;
    right: 0;
    left: unset;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 98%;
      margin-top: 3px;
      transform: rotate(270deg) translateX(${arrowWidth}px);
    }
  }
`;

export const TooltipWrapperContainer = styled.div<TooltipWrapperContainerProps>`
  position: relative;
  width: max-content;
  z-index: 1;
  align-items: center;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: auto;

  > :first-child {
    grid-row: 1;
    grid-column: 1;
  }

  &:hover {
    z-index: 1001;

    .tooltip {
      opacity: 1;
      display: flex;
      gap: 0.25rem;
      animation: ${({ isOpen }) => !isOpen && `fadeInOut ease-in-out 150ms`};
    }
  }

  .status-icon {
    transform: rotate(45deg);
    color: ${styledTheme.color.secondary};
  }

  @keyframes fadeInOut {
    0% {
      display: none;
      opacity: 0;
    }
    1% {
      display: flex;
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
